import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const HeroV1 = (props) => {
    const {
        logoInfo,
        heroCopy,
        display
    } = props;

    if (!display) return null;

    const { link, altText } = (logoInfo || {});

    return (
        <div className={cn('ulx__aem-section')}>
            <div className="ulx__aem-hero__content">
                <h2><img src={link} alt={altText} width="180" height="50" /></h2>
                <div className="ulx__aem-hero__copy">{heroCopy}</div>
            </div>
        </div>
    );
};

HeroV1.propTypes = {
    logoInfo: PropTypes.shape({
        link: PropTypes.string,
        altText: PropTypes.string
    }).isRequired,
    heroCopy: PropTypes.string.isRequired,
    display: PropTypes.bool.isRequired
};

export default HeroV1;
